var map = {
	"./business/purchase/emptor/edit/fields.json": "d03b",
	"./business/purchase/entrystore/edit/fields.json": "7c3f",
	"./business/purchase/stock/edit/fields.json": "2651",
	"./business/sales/deliver/edit/fields.json": "fe9b",
	"./business/sales/quotation/edit/fields.json": "62fb",
	"./business/sales/sale/edit/fields.json": "8e90",
	"./business/sales/saleorder/edit/fields.json": "d388",
	"./business/stock/injectionmolding/edit/fields.json": "7a80",
	"./business/stock/materialoutwarehouse/edit/fields.json": "48c6",
	"./business/stock/otherinbound/edit/fields.json": "527b",
	"./business/stock/otheroutbound/edit/fields.json": "83eb",
	"./business/stock/outsourcedconsumables/edit/fields.json": "2342",
	"./business/stock/outsourcedwarehousing/edit/fields.json": "69b8d",
	"./business/stock/outsourcingpicking/edit/fields.json": "bb1c",
	"./business/stock/patternconversion/edit/fields.json": "15485",
	"./business/stock/pdaproductionpicking/edit/fields.json": "560b",
	"./business/stock/pdaproductionshipping/edit/fields.json": "2631",
	"./business/stock/productionconsumables/edit/fields.json": "7315",
	"./business/stock/productionpicking/edit/fields.json": "4eae",
	"./business/stock/productionshipping/edit/fields.json": "3c90",
	"./business/stock/purchaseinbound/edit/fields.json": "36dc",
	"./business/stock/selloutwarehouse/edit/fields.json": "77dc",
	"./demo/picking/edit/fields.json": "f9af",
	"./demo/purchasein/edit/fields.json": "b441",
	"./demo/sumables/edit/fields.json": "6e82",
	"./production/clothmanagement/newdemand/edit/fields.json": "c914",
	"./production/ticketmanagement/dispatch/edit/fields.json": "ddde",
	"./production/ticketmanagement/injectiondispatch/edit/fields.json": "c5e2",
	"./production/ticketmanagement/materials/edit/fields.json": "f3bb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3a39b";